import { render, staticRenderFns } from "./DiagramModal.vue?vue&type=template&id=24f6a4a2&scoped=true&"
import script from "./DiagramModal.vue?vue&type=script&lang=js&"
export * from "./DiagramModal.vue?vue&type=script&lang=js&"
import style0 from "./DiagramModal.vue?vue&type=style&index=0&id=24f6a4a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f6a4a2",
  null
  
)

export default component.exports